import { Typography } from '@mui/material';
import React from 'react';
import CheckIcon from '../svg/CheckIcon.svg';

const EventPassportRequiredInfo: React.FC<React.PropsWithChildren<unknown>> = () => (
  // const [t] = useTranslation('public');
  <>
    <CheckIcon fontSize="medium" style={{ marginRight: 8 }} />
    <Typography variant="subtitle2" color="primary">
      Jlive Passport required
    </Typography>
  </>
);
export default EventPassportRequiredInfo;
